<div class="flex nordic-blue-900-text pr-medium-b font-body-1" *ngIf="additionalInfoKey$ | async">
  <div class="flex--nogrow">
    <fcom-icon class="icon-small" [name]="SvgLibraryIcon.INFO"></fcom-icon>
  </div>
  <div class="flex-1 ps-xsmall-l">
    {{ additionalInfoKey$ | async | finLocalization }}
  </div>
</div>
